import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Moment from 'react-moment';
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../generics/help';
import testStats from '../patient/testStats';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../config');
var report = require('../../generics/report_head');

class AntibodiesDonors extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.dateCompare = this.dateCompare.bind(this);
		this.generatePdf = this.generatePdf.bind(this);
		this.generateExcel = this.generateExcel.bind(this);

		this.setTable = this.setTable.bind(this);

		this.state = {
			health_facilities_id:"",
			health_facilities: [],

			start_date 	: "",
			end_date 	: "",

			table_list:[],
            listado:[],
            results:[],
            pdf_listado:[],
            pdf_results:[],


			//test datatable to export
			columns_list:[[
                {title:''},
                {title:'Reactivo', colSpan:6},
                {title:'Firmas', colSpan:3}
            ],[
                {title:'Método Analitico'},
                {title:'Antisuero'},
                {title:'Fabricante'},
                {title:'Distribuidor'},
                {title:'No. Lote'},
                {title:'Recepción'},
                {title:'Caducidad'},
                {title:'Realizó'},
                {title:'Reportó'},
                {title:'Revisó'},
            ]],

            columns_results:[
                {title:'No. Prog.', rowSpan:3, width:'100px'},
                {title:'Fecha', rowSpan:3, width:'100px'},
                {title:'No. Donador', rowSpan:3, width:'100px'},
                {title:'No. Unidad', rowSpan:3, width:'100px'},
                {title:'Nombre del Donador', rowSpan:3, width:'300px'},
                {title:'Determinación Sérica',  colSpan:10, cols:[
                    {title:'Salina', colSpan:3, cols:[
                        {title:'I'},
                        {title:'II'},
                        {title:'III'}
                    ]},
                    {title:'Albúmina', colSpan:3, cols:[
                        {title:'I'},
                        {title:'II'},
                        {title:'III'}
                    ]},
                    {title:'Cooms', colSpan:3, cols:[
                        {title:'I'},
                        {title:'II'},
                        {title:'III'}
                    ]},
                    {title:'IgG CCS', rowSpan:2}
                ], width:'450px'},
                {title:'Resultado', rowSpan:3, width:'100px'},
                {title:'Observaciones', rowSpan:3, width:'300px'},
                {title:'Realizó', rowSpan:3, width:'100px'}
            ],
			filename:"Reporte Anticuerpos Irregulares Donadores",

			date_hour:"",
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

	componentDidMount(){
		//this.props.waiting.handleShow('Cargando...');

		fetch(Config.default.apiGateway.URL+'health_facilities', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities: response
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		});

		//this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){
		this.$el = $(this.el);
		var fechas = "Información Del: "+moment(this.state.start_date).format("DD/MM/YYYY")+ 
					" Al: "+moment(this.state.end_date).format("DD/MM/YYYY") 
		
		var btnPdf = {};

		if(this.state.pdf_sero_rep === 'REPORTE'){
			btnPdf = {
				extend: 'pdf',
				title: this.state.filename,
				orientation:'landscape',
				customize: (doc)=> { 
					doc.content.unshift({
						image: this.props.header_document,
						alignment:'center',
						width:this.props.w_head
					});
					doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });
					doc.content.splice(3, 0, {
						columns:[
							this.state.convoke_places_id !== "all" ?
								{text: 'Lugar de Colecta', width:'12%', fontSize:6.5}
							: {text:"", width:0},
							this.state.convoke_places_id !== "all" ?
								{text: this.state.convoke_places_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
							: {text:"", width:0},

							this.state.extraction_type_id !== "all" ?
								{text: 'Extracción', width:'8%', fontSize:6.5}
							: {text:"", width:0},
							this.state.extraction_type_id !== "all" ?
								{text: this.state.extraction_type_name, bold:1, margin:[0,0,0,10], fontSize:6.5}
							: {text:"", width:0},

							this.state.result !== "all" ?
								{text: 'Donación', width:'8%', fontSize:6.5}
							: {text:"", width:0},
							this.state.result !== "all" ?
								{text: this.state.results_name, bold:1, margin:[0,0,0,10], fontSize:6.5}
							: {text:"", width:0}

						]
					});

					this.state.totals.map((r, i)=>{
						var obj = {}
						
						r.results.map((g, j)=>(
							obj = {
								text: r.test+': \t\t'+(g.name === "" ? 'Sin Grupo ' : g.name)+'\t - \t'+g.tot+
										(j !== r.results.length - 1 ? ' / ' : ''), 
								margin: i=== 0 ? [0,15,0,0] : [0,0,0,0],

							}
						))
						
						doc.content.push(obj);
					})
					
					doc.content.push(
						{text:'Total: \t\t'+this.state.count,margin:[5,15,0,30]}
					)


					doc.content.push(
						{columns:[
							{fontSize:7,
							width:'50%',
							alignment:'center',
							text: '_____________________________________________'},
							{fontSize:7,
							width:'50%',
							alignment:'center',
							text: '_____________________________________________'},
						]},
						{columns:[
							{fontSize:7,
							width:'50%',
							alignment:'center',
							text: '(Nombre y Firma)'},
							{fontSize:7,
							width:'50%',
							alignment:'center',
							text: '(Nombre y Firma)'},
						]},
						{columns:[
							{fontSize:7,
							width:'50%',
							alignment:'center',
							text: 'PROCESO Y VALIDO'},
							{fontSize:7,
							width:'50%',
							alignment:'center',
							text: 'QUIEN RECIBE'},
						]},
					)

					

					doc.styles.tableHeader.fontSize = 5;
					doc.defaultStyle.fontSize = 5; 

					doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
				} 
			};
		}else{
			btnPdf = {
				text:'PDF',
				action: (e, dt, node, config)=>{
					var obj = {
						convoke_places_id: this.state.convoke_places_id,
						start_date: this.state.start_date,
						end_date: this.state.end_date,
						start_folio: this.state.start_folio,
						end_folio: this.state.end_folio,
						extraction_type_id: this.state.extraction_type_id,
						donation_type_id: this.state.donation_type_id,
						result: this.state.result,
						format:'serology',
						health_facilities_id:this.state.health_facilities_id,
						report:'PDF_SERO_REP'
					};

					this.props.printPdfReports(obj);
				}
			}
		}
	

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename,
                	messageBottom:()=>{
                		var results = '';
						this.state.totals.map((r, i)=>{
							r.results.map((g, i)=>(
								results += r.test+': '+(g.name === "" ? 'Sin Grupo ' : g.name)+'\t - \t'+g.tot+
										(i !== r.results.length - 1 ? ' / ' : '\n')
								
							))
						})

						return results+'\nTOTAL: \t\t'+this.state.count
						
                	}
            	},
            	btnPdf
            ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sLengthMenu":"Mostrar _MENU_ registros",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfo":"Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered":"(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"oPaginate":{
					"sFirst":"Primero",
					"sLast":"Último",
					"sNext":"Siguiente",
					"sPrevious":"Anterior"},
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.dt-button').disable();
		}else {
			table.buttons('.dt-button').enable();
		}
	}

	handleChange(e){
		
		this.setState({
			[e.target.name]: e.target.value
		});
		

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				this.props.waiting.handleShow('Buscando...');

				var obj = {
					start_date: this.state.start_date,
					end_date: this.state.end_date,
					health_facilities_id:this.state.health_facilities_id
				}
				
				fetch(Config.default.apiGateway.URL+'reports/irregular_antibodies_donors',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					
					if(res.ok){
						return res.json();
					}else{
						this.props.waiting.handleClose();
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
                        var col_results = this.state.columns_results;

                        var list = [];
                        var results = [];
                        var pdf_list = [];
                        var pdf_res = [];
						var body = [];
						
						response.reagents.forEach((reagent, i)=>{
							var obj = [
								'',
								reagent.name,
								reagent.maker,
								reagent.distributor,
								reagent.lot_number,
								reagent.entry_date !== null ? moment(reagent.entry_date).format('DD/MM/YYYY') : "",
								reagent.expiration_Date !== null ? moment(reagent.expiration_Date).format('DD/MM/YYYY') : "",
								"","",""
							];
							
							list.push(obj);
						});

						response.results.forEach((res, i) => {
							results.push([
								res.progresive,
								res.timestamp_date !== null ? moment(res.timestamp_date).format('DD/MM/YYYY') : "",
                                res.donor_number,
                                res.unit_number,
								res.donor_name,
								res.serum_determination.saline_i,
								res.serum_determination.saline_ii,
								res.serum_determination.saline_iii,
                                res.serum_determination.albumin_i,
                                res.serum_determination.albumin_ii,
								res.serum_determination.albumin_iii,
								res.serum_determination.coombs_i,
                                res.serum_determination.coombs_ii,
                                res.serum_determination.coombs_iii,
                                res.serum_determination.igg_ccs,
                                res.result,
                                res.observations,
                                ""
							]);

							if(res.donor_number.length > 10 && i === 0){
								col_results[2].width = '200px';
							}
						});
                                                
                        var body = [];
                        this.state.columns_list.forEach((columns)=>{
                            body = [];
                            columns.forEach(col => {
                                var obj = {text:col.title, style:'tableHeader'};
                                if(col.colSpan !== undefined){
                                    obj.colSpan = col.colSpan;
                                    body.push(obj);
                                    for(var i = 1; i < col.colSpan; i++){
                                        body.push({text:''});
                                    }
                                }else{
                                    body.push(obj);
                                }
                                
                            })
                            pdf_list.push(body);    
                        })

                        list.forEach((listado, i) => {
                            body = [];
                            listado.forEach((l, j)=>{
                                var obj = {
                                    text:l,
                                    style: i % 2 === 0 ? 'tableBodyEven' : 'tableBodyOdd'
                                }

                                body.push(obj);
							})
							
							if(listado.length === 9){
								body.unshift({text:''});
							}

                            pdf_list.push(body);
                        })

						body = [];
						this.state.columns_results.forEach(col => {
							var obj = {text:col.title, style:'tableHeader'}
							if(col.rowSpan !== undefined){
								obj.rowSpan = col.rowSpan;
								body.push(obj);
							}

							if(col.colSpan !== undefined){
								obj.colSpan = col.colSpan;								
								body.push(obj);
								for(var i = 1; i < col.colSpan; i++){
									body.push({text:''});
								}							
							}							
						});
						pdf_res.push(body);
						body = [];
						this.state.columns_results.forEach(col => {
							if(col.cols !== undefined){
								col.cols.forEach((c)=>{
                                    var obj = {text:c.title, style:'tableHeader'}
                                    if(c.rowSpan !== undefined){
                                        obj.rowSpan = c.rowSpan;
                                        body.push(obj);
                                    }

                                    if(c.colSpan !== undefined){
                                        obj.colSpan = c.colSpan;								
                                        body.push(obj);
                                        for(var i = 1; i < c.colSpan; i++){
                                            body.push({text:''});
                                        }							
                                    }

								});
							}else{
								body.push({text:''});
							}							
						});
                        pdf_res.push(body);
                        body = [];
						this.state.columns_results.forEach(col => {
							if(col.cols !== undefined){
								col.cols.forEach((c)=>{
                                    if(c.cols !== undefined){
                                        c.cols.forEach((item)=>{
                                            body.push({text:item.title, style:'tableHeader'});
                                        })
                                    }else{
                                        body.push({text:''});
                                    }
									
								});
							}else{
								body.push({text:''});
							}							
						});
						pdf_res.push(body);
						results.forEach(result => {
							body = [];
							result.forEach((res, i) => {
								var obj = {
                                    text:res,
                                    style: i % 2 === 0 ? 'tableBodyEven' : 'tableBodyOdd'
                                }

                                body.push(obj);
							});
							pdf_res.push(body);
						})
						

						this.setState({
							listado: list,
							results: results,
							pdf_listado: pdf_list,
							pdf_results: pdf_res
						});

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							//this.$el.DataTable().destroy();
							//this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							//this.setTable();
						}, 1000);
					
							
						this.props.waiting.handleClose();
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}
		
		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
    }
    
    generatePdf(e){
        e.preventDefault();

        var fechas = "Información Del: "+moment(this.state.start_date).format("DD/MM/YYYY")+ 
                    " Al: "+moment(this.state.end_date).format("DD/MM/YYYY") 
                    
        var doc = {
            content:[
                {
                    image: this.props.header_document,
                    alignment:'center',
                    width:this.props.w_head
                },
                {text:this.state.filename, style:'title', margin:[0,0,0,12], width:500},
				{text: fechas, margin:[10,0,0,10] },
				
                {
                    layout:'noBorders',
                    table:{
						body:this.state.pdf_listado,
						widths:['10%','10%','10%','10%','10%','10%','10%','10%','10%','10%']
                    },
                    _maxWidth:647.0869140625,
                    _minWidth:479.8798828125
                },
                {text:'', margin:[0,10, 0, 10]},
                {
                    layout:'noBorders',
                    table:{
                        body:this.state.pdf_results,
                        widths:['6%','6%','6%','6%','12.5%','3%','3%','3%','3%','3%','3%','3%','3%','3%','4%','10%','12.5%','10%']
                    },
                    _maxWidth:647.0869140625,
                    _minWidth:479.8798828125   
                }
            ],
            defaultStyle:{fontSize:6.5},
            footer:{text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]},
            pageOrientation:'landscape',
            pageSize:'A4',
            styles:{
                tableBodyEven:{},
                tableBodyOdd:{
                    fillColor:'#f3f3f3'
                },
                tableFooter:{bold:true, fontSize:11, color:'white', fillColor:'#2d4154'},
                tableHeader:{bold:true, fontSize:6.5, color:'white', fillColor:'#2d4154', alignment:'center'},
                title:{alignment:'center', fontSize:15}
            }
        };

        pdfMake.createPdf(doc).download(this.state.filename+'.pdf');
	}
	
	generateExcel(e){
		e.preventDefault();

		var obj = {
			start_date: this.state.start_date,
			end_date: this.state.end_date,
			health_facilities_id:this.state.health_facilities_id
		};

		fetch(Config.default.apiGateway.URL+'reports/generate_excel?report_name=irregular_antibodies_donors',{
			method:'POST',
			body:JSON.stringify(obj),
			responseType: 'blob',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.blob();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				console.log(response)
				this.props.fileDownload(this.state.filename, ".xlsx", 'application/vnd.ms-excel', response);
			}
		})
	}


	render(){
		const {t} = this.props;
		const { selectedOption } = this.state;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Laboratorio ->
					{this.state.filename}
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_laboratory"} 
		            submenu={"help_abo_rh_system_donors"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Centro</span>
									<select type="text" name="health_facilities_id" id="health_facilities_id" 
										value={this.state.health_facilities_id} disabled={!this.state.change_check} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.health_facilities.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.name}
											</option>
										})}
									</select>
								</div>
								
                                <div className="form-group">
                                    <span className="span-min">Fecha Desde</span>
                                    <input type="date" className="form-control hour-input" name="start_date" id="start_date"
                                        value={this.state.start_date} onChange={this.handleChange} required />
                                </div>
                                <div className="form-group">
                                    <span className="span-min">Fecha Hasta</span>
                                    <input type="date" className="form-control hour-input" name="end_date" id="end_date"
                                        value={this.state.end_date} onChange={this.handleChange} required />
                                </div>
							
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
										<span>
											{this.state.filename}
										</span>
									</div>
									<div className="col-xs-12" >
										<span>
											Información Del:  {this.state.start_date !== "" ?
												moment(this.state.start_date).format("DD/MM/YYYY")
											: ''}    
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {this.state.end_date !== "" ?
												moment(this.state.end_date).format("DD/MM/YYYY")
											: ''}
										</span>
									</div>
								</div>

                                <div className="col-xs-12 form-group" style={{textAlign:'right'}}>
									<button className="btn btn-default" disabled={this.state.results.length === 0} onClick={(e)=>this.generateExcel(e)} style={{marginRight:8}}>Excel</button>
									<button className="btn btn-default" disabled={this.state.results.length === 0} onClick={(e)=>this.generatePdf(e)}>PDF</button>
                                </div>

								<div className="col-xs-12 form-group" id="table-list">
									<div className="table-responsive">
										<table style={{fontSize:"10px !important"}} className="table expenses-discards" id="table-to-list" 
											ref={el => this.el = el}>
                                            <thead>
                                                {this.state.columns_list.map((column, i)=>
                                                    <tr key={i}>
                                                        {column.map((col, j)=>
                                                            <th key={j} colSpan={col.colSpan} style={{textAlign:'center'}}>
                                                                {col.title}
                                                            </th>
                                                        )}
                                                    </tr>
                                                )}
                                            </thead>
                                            <tbody>                                                
                                                {this.state.listado.map((listado, i)=>
                                                    <tr key={i}>
                                                        {listado.map((list, j)=>                                                            
                                                            <td key={j} style={{textAlign:j === 1 ? 'left' : 'center'}}>
                                                                {list}
                                                            </td>
                                                        )}
                                                    </tr>                                                    
                                                )}
                                            </tbody>
										</table>
									</div>
								</div>

                                <div className="col-xs-12 form-group" id="table-result">
                                    <div className="table-responsive">
                                        <table style={{fontSize:'10px !important'}} className="table expenses-discards" id="table-to-result">
                                            <thead>
                                                <tr>
                                                    {this.state.columns_results.map((col, i)=>                                                            
                                                        <th key={i} rowSpan={col.rowSpan} colSpan={col.colSpan} style={{width:col.width}}>
                                                            {col.title}
                                                        </th>
                                                    )}
                                                </tr>
                                                <tr>
                                                    {this.state.columns_results.map((column)=>
                                                        column.cols !== undefined &&
                                                            column.cols.map((col, j)=>
                                                                <th key={j} rowSpan={col.rowSpan} colSpan={col.colSpan}>
                                                                    {col.title}
                                                                </th>
                                                            )
                                                        
                                                    )}
                                                </tr>
                                                <tr>
                                                    {this.state.columns_results.map((column)=>
                                                        column.cols !== undefined &&
                                                            column.cols.map((col, j)=>
                                                                col.cols !== undefined &&
                                                                    col.cols.map((c, k)=>
                                                                        <th key={k} colSpan={c.colSpan}>
                                                                            {c.title}
                                                                        </th>
                                                                    )
                                                            )
                                                        
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody>                                                
                                                {this.state.results.map((results, i)=>
                                                    <tr key={i}>
														{results.map((result, j)=>															
                                                            <td key={j}>
                                                                {result}
                                                            </td>
                                                        )}
                                                    </tr>                                                    
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
							
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (AntibodiesDonors);